/**
 * AccountNotSetUpPage.jsx — signed-in user whose users.role is not a known dashboard role.
 * Shaped by: G3b; owner 2026-10-12.
 * Invariants: no apps and no facility dashboard. Missing or empty role still uses /onboarding.
 * Related: pages/dashboard/DashboardPage.jsx, components/auth/Onboarding.jsx.
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useAuth } from "hooks/useAuth";
import logoIcon from "assets/images/logos/logo-icon.png";

const AccountNotSetUpPage = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [logoutLoading, setLogoutLoading] = useState(false);

  const handleSignOut = async () => {
    setLogoutLoading(true);
    try {
      await logout();
      navigate("/");
    } catch (err) {
      console.error("Logout error:", err);
      setLogoutLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.paper",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 4,
      }}
    >
      <Box
        component="img"
        src={logoIcon}
        alt="FusionMSI"
        sx={{ height: 48, mb: 4 }}
      />
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
          mx: "auto",
          px: 3,
        }}
      >
        <Typography variant="h5" component="h1">
          Your account isn't set up yet
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          Contact your administrator to finish setting up your account.
        </Typography>
        <LoadingButton
          sx={{ mt: 3 }}
          loading={logoutLoading}
          onClick={handleSignOut}
        >
          Sign out
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default AccountNotSetUpPage;
